import React, { PropsWithChildren } from "react";
import OutletContext from "./OutletContext";
import useOutletController from "./useOutlet.controller";

export default function OutletProvider(props: PropsWithChildren<{}>) {
  const { children } = props;
  const value = useOutletController();
  return <OutletContext.Provider value={value}>{children}</OutletContext.Provider>;
}
